import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FullBox, Typography } from 'seagull';
import { AnchorLogo } from 'seagull/icons';
import { useLocaleKeys } from '~/i18n';
import styles from './AllSetPage.module.scss';
const NoPermissionsRelationshipApproved = ()=>{
    const { t: noPermissionsApprovedTexts } = useLocaleKeys('clientFlow.noPermissionsApproved');
    return /*#__PURE__*/ _jsx(FullBox, {
        centered: true,
        testId: "reviewer-all-set",
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.reviewerInner,
            children: [
                /*#__PURE__*/ _jsx(AnchorLogo, {
                    height: 44
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "h3",
                    weight: "normal",
                    children: noPermissionsApprovedTexts.alreadySigned()
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "h5",
                    children: noPermissionsApprovedTexts.contactAccountOwner()
                })
            ]
        })
    });
};
export default NoPermissionsRelationshipApproved;
